import {Badge} from "@/lib/components/Badge";
import * as React from "react";
import {useAppTheme} from "@/app/AppThemeContext";
import {CompanyStatus} from "@/api/data-contracts";
import {useTranslation} from "react-i18next";
import { CommonI18N } from "@/translations";
import {color_green, color_grey, color_orange, color_purple, color_red} from "@/agentur/AgenturColors";

/**
 * Returns the translated display text for a given company status.
 * Falls back to the raw status value when no translation key is found.
 */
export function getCompanyStatusText(t: (key: string) => string, status: CompanyStatus | undefined): string {
    if (!status) return "";
    const key = (CommonI18N.enum.companyStatus as Record<CompanyStatus, string>)[status];
    return key ? t(key) : status;
}

function getCompanyStatusColor(mode: string, status: CompanyStatus) {
    switch (status) {
        case CompanyStatus.INVITED:
            return color_green[4];
        case CompanyStatus.UNVERIFIED:
            return color_purple[4];

        case CompanyStatus.CONFIRMED:
            return color_green[2];
        case CompanyStatus.CONFIRMED_LOCKED:
            return color_orange[2];

        case CompanyStatus.REJECTED:
            return color_purple[3];

        case CompanyStatus.TERMINATION_RECEIVED:
            return color_red[2];
        case CompanyStatus.TERMINATION_RECEIVED_LOCKED:
            return color_orange[2];
        case CompanyStatus.TERMINATED:
            return color_grey[1];

        case CompanyStatus.ARCHIVED:
            return color_grey[3];

        case CompanyStatus.OPERATOR:
            return color_grey[3];
        default:
            return color_grey[2];
    }
}

export const CompanyStatusBadge = ({ status, fullWidth }: { status?: CompanyStatus; fullWidth?: boolean }) => {
    const theme = useAppTheme();
    const { t } = useTranslation();
    return (
        status && (
            <Badge
                label={getCompanyStatusText(t, status)}
                backgroundColor={getCompanyStatusColor(theme.mode, status)}
                fullWidth={fullWidth}
            />
        )
    );
};
